import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

export default function HostEventHistoryPage() {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  // Placeholder data
  const pastEvents = [];

  // Gate non-hosts
  useEffect(() => {
    if (!currentUser?.isHost) {
      navigate('/events', { replace: true });
    }
  }, [currentUser, navigate]);

  if (!currentUser?.isHost) return null;

  return (
    <div style={ui.page}>
      <div style={ui.container}>
        <button style={ui.backBtn} onClick={() => navigate('/host')}>
          ← Back to Dashboard
        </button>

        <h1 style={ui.pageTitle}>Past Events</h1>
        <p style={ui.pageSub}>Events you’ve hosted previously.</p>

        {pastEvents.length === 0 ? (
          <p style={ui.emptyText}>No past events yet.</p>
        ) : (
          pastEvents.map((e, idx) => (
            <div key={idx} style={ui.eventRow}>
              <div>
                <strong>{e.name}</strong>
                <div style={ui.metaText}>{e.date}</div>
              </div>
              <div style={ui.metaText}>{e.attendees} attendees</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

/* ===============================
   STYLES
================================ */

const ui = {
  page: {
    background: '#fff',
    minHeight: '100vh',
  },
  container: {
    maxWidth: 760,
    margin: '0 auto',
    padding: 16,
  },
  backBtn: {
    background: 'none',
    border: 'none',
    fontWeight: 800,
    marginBottom: 16,
    cursor: 'pointer',
  },
  pageTitle: {
    fontSize: 22,
    fontWeight: 900,
    marginBottom: 4,
  },
  pageSub: {
    fontSize: 14,
    color: '#555',
    marginBottom: 16,
  },
  eventRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 0',
    borderBottom: '1px solid #EEF0F2',
  },
  metaText: {
    fontSize: 13,
    color: '#555',
  },
  emptyText: {
    fontSize: 13,
    color: '#777',
  },
};
